import React from 'react';

const AvisInformacioAddicionalMonitoritzacioLlampsLlegenda = () => {
    return (
        <div className='avis-informacio-addicional-monitoritzacio-llamps-llegenda' >
            <span className='title'>Tram horari (TU)</span>
            <ul>
                <li>
                    <span style={{backgroundColor: '#3c0064'}} />
                    <span>0</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#6400ff'}} />
                    <span>2</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#0000ff'}} />
                    <span>4</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#0064ff'}} />
                    <span>6</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#00ffff'}} />
                    <span>8</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#00ffb4'}} />
                    <span>10</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#00ff00'}} />
                    <span>12</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#b4ff00'}} />
                    <span>14</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#ffff00'}} />
                    <span>16</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#ffb400'}} />
                    <span>18</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#ff6400'}} />
                    <span>20</span>
                </li>
                <li>
                    <span style={{backgroundColor: '#ff0000'}} />
                    <span>22</span>
                </li>
            </ul>
        </div>
    );
};

export default AvisInformacioAddicionalMonitoritzacioLlampsLlegenda;


// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalMonitoritzacioLlampsLlegenda.js